// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var offsetHomeRouter = {
  path: '/offsetHome',
  component: Layout,
  redirect: '/offsetHome/home',
  name: 'offsetHome',
  alwaysShow: true,
  meta: {
    title: '核销',
    icon: 'clipboard'
  },
  children: [{
    path: 'home',
    name: "home",
    meta: {
      title: '核销首页'
    },
    component: function component() {
      return import('@/views/offsetHome/home/index');
    }
  }]
};
export default offsetHomeRouter;